import apiClient from './apiClient';
import StreakService from './StreakService';
import { getEndPracticeImage } from './TrainerAssets';
import { getPlayerLevel } from '../utils/celebrationHelpers';
import { getNewlyUnlockedRecordAchievementIds } from '../utils/recordAchievements';
import { RECORD_ACHIEVEMENT_VISUALS } from './RecordCelebrationVisuals';
import { t } from '../i18n';
import videoWebm from '../assets/videos/level-up-ceremony.webm';
import videoMp4 from '../assets/videos/level-up-ceremony.mp4';
import poster from '../assets/videos/level-up-ceremony-poster.webp';

export async function writingCelebrationSnapshot() {
  const [profile, streak] = await Promise.all([
    apiClient.getCurrentUserSummary().catch(() => null),
    new StreakService().getStreakData().catch(() => null),
  ]);
  return { profile, streak };
}

export async function writingCelebrations(before) {
  const after = await writingCelebrationSnapshot();
  const queue = [];
  if (before?.streak?.hasPracticedToday === false && after.streak?.hasPracticedToday) {
    queue.push({ kind: 'streak', title: t('writingExam.streakTitle'),
      message: t('writingExam.streakMessage', undefined, { count: after.streak.streak || 1 }),
      iconSrc: getEndPracticeImage(), iconAlt: t('writingExam.trainerMin') });
  }
  const previousLevel = getPlayerLevel(before?.profile?.summary);
  const level = getPlayerLevel(after.profile?.summary);
  if (previousLevel && level > previousLevel) queue.push({ kind: 'level', colorTheme: 'level-up',
    title: t('playerLevelUp.title'), message: t('playerLevelUp.message', undefined, { previousLevel, level }),
    animationVideoWebmSrc: videoWebm, animationVideoMp4Src: videoMp4, animationVideoPosterSrc: poster,
    animationFrameSize: 240, animationDurationMs: 2000 });
  if (before?.profile && after.profile) {
    for (const id of getNewlyUnlockedRecordAchievementIds(before.profile, after.profile)) {
      const visual = RECORD_ACHIEVEMENT_VISUALS[id];
      if (visual) queue.push({ kind: id, title: t('recordAchievement.title'),
        message: t('recordAchievement.message', undefined, { record: t(visual.labelKey) }),
        iconSrc: visual.artwork, iconAlt: t(visual.labelKey), iconLayout: 'wide' });
    }
  }
  return queue;
}
